const TIMEOUT_DURATION = 2000
const SUPPORT_URL = "https://support.yoco.help/en/"

let intercomShown = false

export const showIntercom = () => {
  if (typeof window.Intercom === "function") {
    window.Intercom("onShow", () => {
      intercomShown = true
    })

    window.Intercom("show")

    setTimeout(() => {
      if (!intercomShown) {
        globalThis.location.assign(SUPPORT_URL)
      }
      intercomShown = false
    }, TIMEOUT_DURATION)
  } else {
    globalThis.location.assign(SUPPORT_URL)
  }
}
